import { render } from "./loadbalancer.harvesterhci.io.ippool.vue?vue&type=template&id=4428b662"
import script from "./loadbalancer.harvesterhci.io.ippool.vue?vue&type=script&lang=js"
export * from "./loadbalancer.harvesterhci.io.ippool.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__